export const baseURL = "https://mp-crm.ru/api/v1/";

export const errorMessage =
  "На сервере произошла ошибка. \
Пожалуйста, попробуйте перезагрузить страницу или \
свяжитесь с администратором.";